<template>
    <div id="bus_reservation" class="d-flex align-items-center justify-content-between py-10 container" >
        <div class="col-md-12 p-0">
            <div class="card card-custom">
                <div class="card-header">
                    <div class="card-title">
                        <span class="card-icon">
                            <i class="fas fa-bus text-aqua"></i>
                        </span>
                        <h1 class="card-label text-uppercase">Bus Reservation</h1>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12 py-5 px-7">
                          <h3>Reserve your bus in just a few simple steps</h3><br/>
                          <p>Start by providing your basic trip details. We’ll instantly review your request and suggest the best bus options for your needs.</p>
                          <p>After you choose your preferred bus type, submit your contact information and any special requirements. Our team will confirm availability, send you the final quotation, and guide you through the payment process.</p>
                          <p>Once confirmed, your bus will arrive at the pick-up point on time, and our support team will stay connected to ensure a smooth and comfortable journey.</p>
                          <!--<ul>
                            <li>confirm your reservations with respective service providers;</li>
                            <li>keep you informed of the transaction status;</li>
                          </ul>-->
                        </div>
                    </div>
                    <v-form
                        ref="form"
                        v-model="valid"
                    >
                      <div class="row">
                        <div class="col-sm-8 offset-sm-2">
                          <div class="form-group">
                            <h2 class="text-blue" style="margin:10px 0px 20px 0px; text-align:center; color:#EC1C24; ">
                              Reserve Your Bus In A Few Steps
                            </h2>
                            <h3 class="text-black-50" style="text-align: center; margin-bottom: 30px;">
                              Please providing your trip's basic details
                            </h3>
                          </div>
                          <div>
                            <div class="row">
                              <div class="col-md-6">
                                <h4 class="input-level text-blue"><i class="far fa-fw fa-star text-danger"></i>Contact Person Name:</h4>
                                <v-text-field
                                    dense
                                    outlined
                                    v-model="form.name"
                                    :rules="[ v => !!v || 'Name is required']"
                                    required
                                ></v-text-field>
                              </div>
                              <div class="col-md-6">
                                <h4 class="input-level text-blue"><i class="far fa-fw fa-star text-danger"></i>Contact Person Mobile Number:</h4>
                                <v-text-field
                                    dense
                                    outlined
                                    v-model="form.mobile"
                                    :rules="[ v => !!v || 'Mobile is required']"
                                    required
                                ></v-text-field>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6">
                                <h4 class="input-level text-blue"><i class="far fa-fw fa-star text-danger"></i>Journey Date:</h4>
                                <DatePicker
                                    v-model="form.journey_date"
                                    :masks="masks"
                                    :min-date="disableDate"
                                    color="blue"
                                    style="background-color: white;" >
                                  <template v-slot="{ inputValue, inputEvents }">
                                    <input
                                        class="px-2 py-1 rounded focus:outline-none focus:border-blue-300 form-control"
                                        style="border: 1px solid #ababab; margin-bottom: 25px;"
                                        :value="inputValue"
                                        v-on="inputEvents"
                                    />
                                  </template>
                                </DatePicker>
                              </div>
                              <div class="col-md-6">
                                <h4 class="input-level text-blue"><i class="far fa-fw fa-star text-danger"></i>Return Date:</h4>
                                <DatePicker
                                    v-model="form.return_date"
                                    :masks="masks"
                                    :min-date="disableDate"
                                    color="blue"
                                    style="background-color: white;" >
                                  <template v-slot="{ inputValue, inputEvents }">
                                    <input
                                        class="px-2 py-1 rounded focus:outline-none focus:border-blue-300 form-control"
                                        style="border: 1px solid #ababab; margin-bottom: 25px;"
                                        :value="inputValue"
                                        v-on="inputEvents"
                                    />
                                  </template>
                                </DatePicker>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6">
                                <h4 class="input-level text-blue"><i class="far fa-fw fa-star text-danger"></i>Number of Person:</h4>
                                <v-text-field
                                    dense
                                    outlined
                                    v-model="form.total_person"
                                    :rules="[ v => !!v || 'Number of Person is required']"
                                    required
                                ></v-text-field>
                              </div>
                              <div class="col-md-6">
                                <h4 class="input-level text-blue"><i class="far fa-fw fa-star text-danger"></i>Organization Type:</h4>
                                <v-select
                                    v-model="form.org_type"
                                    :items="org_types"
                                    item-text="name"
                                    item-value="value"
                                    dense
                                    outlined
                                ></v-select>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6">
                                <h4 class="input-level text-blue"><i class="far fa-fw fa-star text-danger"></i>Trip Type:</h4>
                                <v-select
                                    v-model="form.trip_type"
                                    :items="trip_types"
                                    item-text="name"
                                    item-value="value"
                                    dense
                                    outlined
                                ></v-select>
                              </div>
                              <div class="col-md-6">
                                <h4 class="input-level text-blue"><i class="far fa-fw fa-star text-danger"></i>Preferred Bus Type:</h4>
                                <v-select
                                    v-model="form.bus_type"
                                    :items="bus_types"
                                    item-text="name"
                                    item-value="value"
                                    dense
                                    outlined
                                ></v-select>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6">
                                <h4 class="input-level text-blue"><i class="far fa-fw fa-star text-danger"></i>Pick-up Location:</h4>
                                <v-text-field
                                    dense
                                    outlined
                                    v-model="form.pick_up"
                                    :rules="[ v => !!v || 'Pick-up Location is required']"
                                    required
                                ></v-text-field>
                              </div>
                              <div class="col-md-6">
                                <h4 class="input-level text-blue"><i class="far fa-fw fa-star text-danger"></i>Drop-off Location:</h4>
                                <v-text-field
                                    dense
                                    outlined
                                    v-model="form.drop_off"
                                    :rules="[ v => !!v || 'Drop-off Location is required']"
                                    required
                                ></v-text-field>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-12">
                                <h4 class="input-level text-blue">Special Requirement:</h4>
                                <v-textarea
                                    label=""
                                    v-model="form.special_requirement"
                                    outlined
                                    rows="5"
                                ></v-textarea>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-8 offset-4 mb-5" align="center" style="text-align: center;">
                                <div id="captcha-element"
                                    style="text-align: center;" align="center">
                                </div>
                              </div>
                            </div>
                            <div class="form-group" style="margin:0px 0px;">
                              <div class="col-sm-6 offset-sm-3" align="center">
                                <button id="bus_reserve_btn" type="button" style="font-size: 16px; font-weight: 600;" class="btn btn-primary btn-md btn-block" @click="submitForm">
                                  SUBMIT
                                </button>
                              </div>
                            </div>
                          </div>
                          <div id="submit-done">
                            <div class="form-group col-md-12">
                              <h4 class="text-green" style="text-align: center;" id="submit-done-msg"></h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-form>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .spinner.spinner-right {
        padding-right: 3.5rem !important;
    }
    .bg-green{
        background-color: #20b887 !important;
        color:white;
    }
</style>

<script>
    import DatePicker from 'v-calendar/lib/components/date-picker.umd.min'
    import {mapGetters} from "vuex";

    export default {
      name: "BusReservation",
      components:{
        DatePicker
      },
      data() {
        return {
          form:{
            name: '',
            mobile: '',
            journey_date: '',
            return_date: '',
            total_person: '',
            org_type: '',
            trip_type: '',
            bus_type: '',
            pick_up: '',
            drop_off: '',
            special_requirement: '',
          },
          trip_types: [{name:'One-Way',value:'One-Way'}, {name:'Round Trip',value:'Round Trip'}],
          bus_types: [
              {name:'AC',value:'AC'},
              {name:'Non-AC',value:'Non-AC'},
              {name:'Sleeper',value:'Sleeper'},
              {name:'Double-Decker',value:'Double-Decker'},
          ],
          org_types: [
              {name:'Personal',value:'Personal'},
              {name:'Corporate',value:'Corporate'},
              {name:'School',value:'School'},
              {name:'University',value:'University'},
          ],
          masks: {
            input: 'D MMM YYYY',
          },
          disableDate: new Date(new Date().setDate(new Date().getDate() + 2)),
          valid: false,
          profileData : null,
          captchaWidgetId: null,
          captchaToken: ""
        };
      },
      computed:{
          ...mapGetters(['getCompanyInfo'])
      },
      mounted() {
        this.initRecaptcha();
      },
      methods: {
        async submitForm() {
          if (!this.$refs.form.validate()) return;
          // Get recaptcha token
          if (!this.captchaToken) {
            alert("Please complete the reCAPTCHA.");
            return;
          }
          const emailBody = `
                      ~:: Bus Reservation Request ::~
                      <1> Contact Person :- ${this.form.name}
                      <2> Mobile Number :- ${this.form.mobile}
                      <3> Trip Type :- ${this.form.trip_type}
                      <4> Journey Date :- ${this.formatDate(this.form.journey_date)}
                      <5> Return Date :- ${this.formatDate(this.form.return_date)}
                      <6> Total Person :- ${this.form.total_person}
                      <7> Organization Type :- ${this.form.org_type}
                      <8> Preferred Bus Type :- ${this.form.bus_type}
                      <9> Pick-up Location :- ${this.form.pick_up}
                      <11> Drop-off Location :- ${this.form.drop_off}
                      <12> Special Requirements :- ${this.form.special_requirement || "N/A"}
                  `;
          //console.log(emailBody);
          const formData = new FormData();
          formData.append("access_key", "69e5a2ae-0e1e-48d7-ba31-5b090c3c5333");
          formData.append("subject", "Bus Reservation Request");
          formData.append("from_name", "Chokrojan.com");
          formData.append("message", emailBody);
          try {
            fetch("https://api.web3forms.com/submit", {
              method: "POST",
              body: formData
            }).then(res => res.json())
              .then(() => {
                alert("Your reservation request has been submitted successfully!");
                setTimeout(() => {
                  window.location.reload();
                }, 500);
              })
              .catch(() => alert("Failed to submit request."));
          } catch (error) {
            alert("Failed to send reservation request. Please try again.");
          }
        },
        initRecaptcha() {
          // Script exists but not initialized yet
          if (!window.recaptchaLoaded || !window.grecaptcha || !window.grecaptcha.render) {
            setTimeout(this.initRecaptcha, 200);
            return;
          }
          // Render only once
          this.$nextTick(() => {
            this.captchaWidgetId = grecaptcha.render("captcha-element", {
              sitekey: "6LcMdCUsAAAAAH--hg43HPFCUD8uHAwqVL-gUgKD",
              callback: (token) => {
                this.captchaToken = token;
              }
            });
          });
        },
        formatDate(date) {
          if (!date) return "";
          return new Date(date).toLocaleDateString("en-US", {
            weekday: "long",
            month: "short",
            day: "numeric",
            year: "numeric"
          });
        }
      },
    }
</script>
